export default {
    games: {
        "hell-sheep": {
            id: "hell-sheep",
            name: "HELL Sheep",
            image: "/static/files/p/ic_launcher120.png",
            flag: "new",
            like: 6,
            votes: 100,
            desc: "Are you challenge today? I heard that the game clear rate is only 0.01%, come and challenge! Let's see who can pass the hell tile first~",
            path: "/static/games/hell-sheep/",
            category: 1,
            gameType: 1,
            //android:"https://play.google.com/store/apps/details?id=com.hot.yangyang"
        },
        "pet-island": {
            id: "pet-island",
            name: "PET ISLAND",
            image: "/static/files/p/41a88760b2555de4156e440a12070f1e.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Be a Survivor on a desert island! Explore the world, hunt animals, collect resources, mine ore, craft tools, grow vegetables. Build a house & farm for free! Idle farming & mining in the village settlement. Sell and buy goods on the market. A stranded castaway, evolve simulator.",
            path: "/static/games/pet-island/",
            category: 1,
            gameType: 1,
        },
        "SaveTheDoge": {
            id: "SaveTheDoge",
            name: "SAVE THE DOGE",
            image: "/static/files/p/729b5d98f39bce22929e828868d83e7a.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Save The Dog is a casual puzzle game. You draw lines with your fingers to create walls that protect the dog from attacks by bees in the hive. You need to protect the dog with the painted wall for 10 seconds during the attack of the bees, hold on and you will win the game.Use your brain to save the doge.",
            path: "/static/games/save-the-doge/",
            category: 1,
            gameType: 1,
        },
        "SubwaySurfersIceland": {
            id: "SubwaySurfersIceland",
            name: "SUBWAY SURFERS ICELAND",
            image: "/static/files/p/ec072ba7373f6f2f9a4b259d4f1474c0.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "The Subway Surfers are traveling to beautiful Iceland. Grind trains among blasting geysers and smoldering volcanoes. Improve your Surfer crew with Bjarki the strong explorer",
            path: "/static/games/subway-surfers-iceland/",
            category: 1,
            gameType: 1,
        },
        "aquapark-shark": {
            id: "aquapark-shark",
            name: "AQUAPARK THRILLS",
            image: "/static/files/p/d607b15e8343768cb9ff2ef51aa98dd5.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Welcome to the fun in Aquapark Shark water slide pool racing adventure where dreams are born and people come to beat the summer heat! Have fun at the aqua slides, uphill rush crazy rides adventure park racing games! Play all kinds of water pool race activities in uphill rush water park racing game to make this summer the best fun filled summer with water splash fun aqua racing adventure!",
            path: "/static/games/aquapark-shark/",
            category: 1,
            gameType: 1,
        },
        "moon_pioneer_online": {
            id: "moon_pioneer_online",
            name: "MOON PIONEER ONLINE",
            image: "/static/files/p/moon_pioneer_online.jpg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Collect oil, build factories and explore the entire universe!",
            path: "/static/games/moon-pioneer-online/",
            category: 1,
            gameType: 1,
        },
        "beat-rhythm-run": {
            id: "beat-rhythm-run",
            name: "Beat Rhythm Run",
            image: "/static/files/p/cc7c0650f0a1ab1fc86c9e0ae2058f22.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Move and drag your finger to smash the circles! Listen to the music, keep your pace with fancy rhythm! <br />Sound easy? You wish!!",
            path: "/static/games/beat-rhythm-run/",
            category: 1,
            gameType: 1,
        },
        "bloody battle": {
            id: "bloody battle",
            name: "BLOODY BATTLE",
            image: "/static/files/p/c5a0851b1d40abdb709457613010f028.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "The classic returns, the bloody battlefield, bring your old equipment, return to the battlefield, sway your passion, and enjoy the roar of artillery fire and bullets on the battlefield. Pay attention to the level boss, your combat power may not be able to beat!",
            path: "/static/games/bloody-battle/",
            category: 1,
            gameType: 1,
        },
        "human-evolution": {
            id: "human-evolution",
            name: "HumanEvolutionRun",
            image: "/static/files/p/5e7962be007069987919d198666b0875.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "In Human Evolution Run, you can grow and evolve your crowd and beat the enemies!",
            path: "/static/games/human-evolution/",
            category: 1,
            gameType: 1,
        },
        "RadishGirl": {
            id: "RadishGirl",
            name: "RADISHGIRL ONLINE",
            image: "/static/files/p/6fde6739c9cc9eb176da5fe1752c3df3.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "A rural landscape that quietly unfurls. With unproportionally large radishes and the high school girl clinging to them superimposed on that landscape. The high school girl is single-mindedly determined to climb the towering radishes.",
            path: "/static/games/radish-girl/",
            category: 1,
            gameType: 1,
        },


        "TeethRunner": {
            id: "TeethRunner",
            name: "TEETH RUNNER ONLINE",
            image: "/static/files/p/8c38791002ef487ba6a8d819f6bec3ab.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "Welcome to Teeth Runner, the greatest teeth game you’ve ever played ! In Teeth Runner, the simple goal is to brush the teeth of people : humans, zombies, vampires, muchachos … They all require different ingredients, so be careful while you brush their teeth, to pick up the right toothpaste !",
            path: "/static/games/teeth-runner/",
            category: 1,
            gameType: 1,
        },
        "atom-war": {
            id: "atom-war",
            name: "ATOM WAR",
            image: "/static/files/p/ca4aee2f6916431224822aceaa88eaf5.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "A fun casual fighting game. In your body, you are facing the threat of viruses all the time, so you must fight them to the end, you can equip different weapons and upgrade them to defeat the virus and win.",
            path: "/static/games/atom-war/",
            category: 1,
            gameType: 1,
        },
        "robot-hunter": {
            id: "robot-hunter",
            name: "ROBOT HUNTER",
            image: "/static/files/p/robothunter.jpg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Follow the prompts to find teammates to upgrade yourself, pay attention to position to avoid damage, get gold coins through levels to buy powerful characters!",
            path: "/static/games/robot-hunter/",
            category: 1,
            gameType: 1,
        },
        "food-empire-inc": {
            id: "food-empire-inc",
            name: "FOOD EMPIRE INC",
            image: "/static/files/p/food-empire-inc.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Grow your sky farm empire and be a high tech billionaire in this idle farming game.Grow lettuce, strawberry, watermelon, lavender, mint, carrots, tomatoes and even GINSENG, in the sky!Use the coins to upgrade your operations.Hire sophisticated managers to automate your tasks.Build new sky farms, high in the sky.Earn money while you sleep, from your Food Empire.",
            path: "/static/games/food-empire-inc/",
            category: 1,
            gameType: 1,
        },
        "hunter-assassin2": {
            id: "hunter-assassin2",
            name: "HUNTER ASSASSIN 2",
            image: "/static/files/p/hunter-assassin2.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Become the legend of Assassin and prepare for combat every starge. Use your skills and escape from the enemies.The hunters lurk everywhere and are armed with automatic shot gun, so you must stay alert and keep a safe distance from those aggressive hunters. Each hunter destroyed you have the opportunity to get more gold to upgrade new skills to give you more speed and power to easily cross the level.",
            path: "/static/games/hunter-assassin2/",
            category: 1,
            gameType: 1,
        },
        // "food-empire-inc":{
        //     id:"food-empire-inc",
        //     name:"WATER PARK WAR",
        //     image:"/static/files/p/WaterParkWar.jpeg",
        //     flag:"hot",
        //     like:6,
        //     votes:100,
        //     desc:"The goal of the game is to kick your opponents into the water. You can only seize the right time, don't touch their scanning range, and then put them into the water one by one.",
        //     path:"/static/games/WaterParkWar/",
        //     category:1,
        //     gameType:1,
        // },
        "power-light": {
            id: "power-light",
            name: "Power Light",
            image: "/static/files/p/power-light.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Power Light is a tile-matching puzzle game inspired by Pipe Mania. Click on line-patterned tiles to rotate them, and connect batteries with lightbulbs in order to progress through the game.",
            path: "/static/games/power-light/",
            category: 1,
            gameType: 1,
        },
        "BridgeRunRace": {
            id: "BridgeRunRace",
            name: "BLOB BRIDGE RACE",
            image: "/static/files/p/BridgeRunRace.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Pave the way by collecting bricks to see who is the fastest one. Don't let others steal your bridge!",
            path: "/static/games/bridge-run-race/",
            category: 1,
            gameType: 1,
        },
        "scarabaeus": {
            id: "scarabaeus",
            name: "SCARABAEUS",
            image: "/static/files/p/scarabaeus.png",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Utilise the unique abilities of different block-headed characters and interact with switches and levers to collect all the golden beetles in each level.",
            path: "/static/games/scarabaeus/",
            category: 1,
            gameType: 1,
        },
        "fieldrunners-td": {
            id: "fieldrunners-td",
            name: "FIELDRUNNERS TD",
            image: "/static/files/p/fieldrunners-td.jpeg",
            flag: "hot",
            like: 6,
            votes: 100,
            desc: "Get ready to DEFEND THE WORLD! Fieldrunners TD has arrived! Build epic mazes out of powerful weapons to defend the world from the invading fieldrunners!The fieldrunners are back! With legions of soldiers and a gaggle of new tricks, they’re ready to conquer the globe. Or so they think! Our top scientists at SubaLabs have built a bleeding-edge arsenal of devastating weapons for any heroes willing to stop these dastardly invaders. Help your people by taking action - DEFEND THE WORLD!.",
            path: "/static/games/fieldrunners-td/",
            category: 1,
            gameType: 1,
        },
        "tanks-a-lot": {
            id: "tanks-a-lot",
            name: "TANKS A LOT",
            image: "/static/files/p/tanks-a-lot.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "Enter this world of epic battles and powerful tanks in realtime action against others. Defeat the enemy combat vehicles and be the last man standing in Battle Royale mode. Tanks a lot! is a fascinatingly deep experience that requires careful strategy in each lightning-fast battle!",
            path: "/static/games/tanks-a-lot/",
            category: 1,
            gameType: 1,
        },


        // "tanks-a-lot1":{
        //     id:"tanks-a-lot1",
        //     name:"TANKS A LOT",
        //     image:"/static/files/p/tanks-a-lot.jpeg",
        //     flag:"",
        //     like:6,
        //     votes:100,
        //     desc:"Enter this world of epic battles and powerful tanks in realtime action against others. Defeat the enemy combat vehicles and be the last man standing in Battle Royale mode. Tanks a lot! is a fascinatingly deep experience that requires careful strategy in each lightning-fast battle!",
        //     path:"/static/games/StoneRunRun/",
        //     category:1,
        //     gameType:1,
        // },
        "moto": {
            id: "moto",
            name: "MOTO RUSH",
            image: "/static/files/p/moto.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "Rush down the street as you try to take first place in this fun online racing game. Jump on your bike, then drive towards speed boosts and ramps. If you crash it is game over! Try to top the leaderboard in this fun high score game based on the popular app Bike Rush.",
            path: "/static/games/moto/",
            category: 1,
            gameType: 1,
        },

        "mergeEmpires": {
            id: "mergeEmpires",
            name: "MergeEmpires",
            image: "/static/files/p/mergeEmpires.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "Enter this world of epic battles and powerful tanks in realtime action against others. Defeat the enemy combat vehicles and be the last man standing in Battle Royale mode. Tanks a lot! is a fascinatingly deep experience that requires careful strategy in each lightning-fast battle!",
            path: "/static/games/merge-empires/",
            category: 1,
            gameType: 1,
        },
        "tropical-merge": {
            id: "tropical-merge",
            name: "Tropical Merge",
            image: "/static/files/p/tropical-merge.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "Enter this world of epic battles and powerful tanks in realtime action against others. Defeat the enemy combat vehicles and be the last man standing in Battle Royale mode. Tanks a lot! is a fascinatingly deep experience that requires careful strategy in each lightning-fast battle!",
            path: "/static/games/tropical-merge/",
            category: 1,
            gameType: 1,
        },
        "ttt": {
            id: "ttt",
            name: "ttt",
            image: "/static/files/p/.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "Enter this world of epic battles and powerful tanks in realtime action against others. Defeat the enemy combat vehicles and be the last man standing in Battle Royale mode. Tanks a lot! is a fascinatingly deep experience that requires careful strategy in each lightning-fast battle!",
            path: "/static/games/ttt/",
            category: 1,
            gameType: 1,
        },
        "That-s-My-Seat": {
            id: "That-s-My-Seat",
            name: "That's My Seat",
            image: "/static/files/p/That-s-My-Seat.jpeg",
            flag: "",
            like: 6,
            votes: 100,
            desc: "Enter this world of epic battles and powerful tanks in realtime action against others. Defeat the enemy combat vehicles and be the last man standing in Battle Royale mode. Tanks a lot! is a fascinatingly deep experience that requires careful strategy in each lightning-fast battle!",
            path: "/static/games/that-s-my-seat/",
            category: 1,
            gameType: 1,
        },
        "thread-sort": {
            id: "thread-sort",
            name: "Thread Sort",
            image: "/static/files/p/thread-sort.jpg",
            flag: "new",
            like: 0,
            votes: 100,
            desc: "采集自 GameDistribution - 在线 HTML5 游戏",
            path: "/static/games/thread-sort/",
            category: 1,
            gameType: 1
        },

        //https://html5.gamedistribution.com/6dc037f772464aab985193ee5160c309/
        //https://html5.gamedistribution.com/rvvASMiM/7d3cb3e86606402aa42c39821fbfc364/
        //https://html5.gamedistribution.com/ddcba9beafaf409ab581385023761cde/
        //Fieldrunners TD
    },
    getGame(name) {
        try {
            let info = this.games[name];
            return info;
        } catch (e) {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/config/games.js